"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _generalStore = require("general-store");

var _draftJs = require("draft-js");

var _draftExtend = require("draft-extend");

var _links = _interopRequireDefault(require("crm_internal/config/links"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _loggers = require("customer-data-tracking/loggers");

var _MeetingsStore = _interopRequireDefault(require("crm_data/meeting/MeetingsStore"));

var _UserSettingsStore = _interopRequireDefault(require("crm_data/settings/UserSettingsStore"));

var _UserSettingsActions = require("crm_data/settings/UserSettingsActions");

var _UserSettingsKeys = _interopRequireDefault(require("crm_data/settings/UserSettingsKeys"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var toI18nText = function toI18nText(name, opts) {
  return _I18n.default.text("plugins.meetingsProTipPlugin." + name, opts);
};

var dependencies = {
  meetingLinks: {
    stores: [_MeetingsStore.default],
    deref: function deref() {
      return _MeetingsStore.default.get({
        onlyUser: false
      }).get('meetingsLinks');
    }
  },
  hideMeetingsProTip: {
    stores: [_UserSettingsStore.default],
    deref: function deref() {
      return _UserSettingsStore.default.get(_UserSettingsKeys.default.HIDE_MEETINGS_PRO_TIP);
    }
  }
};
var MeetingsProTip = (0, _createReactClass.default)({
  propTypes: {
    entityKey: _propTypes.default.string,
    children: _propTypes.default.any,
    contentState: _propTypes.default.object,
    meetingLinks: _propTypes.default.instanceOf(_immutable.List),
    hideMeetingsProTip: _propTypes.default.bool
  },
  contextTypes: {
    getEditorState: _propTypes.default.func,
    onChange: _propTypes.default.func
  },
  getInitialState: function getInitialState() {
    var hideMeetingsProTip = this.props.hideMeetingsProTip;
    return {
      open: !hideMeetingsProTip,
      isDismissChecked: false
    };
  },
  componentDidMount: function componentDidMount() {
    _loggers.CrmLogger.logRecordInteraction(_ObjectTypes.CONTACT, {
      action: 'MeetingsProTip - Opened'
    });
  },
  getEntity: function getEntity() {
    var _this$props = this.props,
        entityKey = _this$props.entityKey,
        contentState = _this$props.contentState;
    return contentState.getEntity(entityKey);
  },
  maybePreventFuturePopups: function maybePreventFuturePopups() {
    if (this.state.isDismissChecked) {
      (0, _UserSettingsActions.saveUserSetting)(_UserSettingsKeys.default.HIDE_MEETINGS_PRO_TIP, true);

      _loggers.CrmLogger.logRecordInteraction(_ObjectTypes.CONTACT, {
        action: 'MeetingsProTip - Clicked to permanently disable popover'
      });
    }
  },
  handleClose: function handleClose() {
    this.maybePreventFuturePopups();

    _loggers.CrmLogger.logRecordInteraction(_ObjectTypes.CONTACT, {
      action: 'MeetingsProTip - Dismissed'
    });

    this.setState({
      open: false
    });
  },
  handleMeetingsInsert: function handleMeetingsInsert() {
    var _this$context = this.context,
        getEditorState = _this$context.getEditorState,
        onChange = _this$context.onChange;
    var _this$props2 = this.props,
        entityKey = _this$props2.entityKey,
        meetingLinks = _this$props2.meetingLinks;
    var editorState = getEditorState();
    var defaultMeetingLink = meetingLinks.find(function (meeting) {
      return meeting.get('isDefaultLink');
    }).get('link');

    var _this$getEntity$getDa = this.getEntity().getData(),
        phrase = _this$getEntity$getDa.phrase,
        offset = _this$getEntity$getDa.offset,
        blockKey = _this$getEntity$getDa.blockKey;

    var meetingSelection = _draftJs.SelectionState.createEmpty(blockKey).merge({
      anchorOffset: offset,
      focusOffset: offset + phrase.length
    });

    var editorStateWithSelection = _draftJs.EditorState.forceSelection(editorState, meetingSelection);

    var entitySelection = _draftExtend.pluginUtils.getEntitySelection(editorState, entityKey);

    var entityStyles = _draftExtend.pluginUtils.getSelectedInlineStyles(_draftJs.EditorState.forceSelection(editorState, entitySelection));

    var contentStateWithEntity = editorState.getCurrentContent().createEntity('LINK', 'MUTABLE', {
      text: phrase,
      url: defaultMeetingLink
    });
    var linkEntityKey = contentStateWithEntity.getLastCreatedEntityKey();

    var editorStateWithMeeting = _draftJs.EditorState.push(editorStateWithSelection, _draftJs.Modifier.replaceText(contentStateWithEntity, entitySelection, phrase, entityStyles, linkEntityKey), 'update-entity');

    onChange(editorStateWithMeeting);
    this.maybePreventFuturePopups();

    _loggers.CrmLogger.logRecordInteraction(_ObjectTypes.CONTACT, {
      action: 'MeetingsProTip - Inserted a meetings link from auto detection popover'
    });
  },
  handleSetupMeeting: function handleSetupMeeting() {
    _loggers.CrmLogger.logRecordInteraction(_ObjectTypes.CONTACT, {
      action: 'MeetingsProTip - Sent to MeetingsUI for onboarding'
    });

    this.setState({
      open: false
    });
  },
  handleDismissCheckChange: function handleDismissCheckChange(_ref) {
    var target = _ref.target;
    this.setState({
      isDismissChecked: target.checked
    });
  },
  renderConfirmButton: function renderConfirmButton() {
    var meetingLinks = this.props.meetingLinks;

    if (meetingLinks === -1) {
      return _react.default.createElement(_UIButton.default, {
        use: "primary",
        onClick: this.handleSetupMeeting,
        href: _links.default.meetings(),
        target: "_blank"
      }, toI18nText('setUpMeeting'));
    }

    return _react.default.createElement(_UIButton.default, {
      use: "primary",
      onClick: this.handleMeetingsInsert
    }, toI18nText('turnIntoMeeting'));
  },
  renderFooter: function renderFooter() {
    return _react.default.createElement("div", null, _react.default.createElement(_UIFlex.default, {
      className: "m-bottom-3"
    }, this.renderConfirmButton(), _react.default.createElement(_UIButton.default, {
      onClick: this.handleClose
    }, toI18nText('dismiss'))), _react.default.createElement(_UICheckbox.default, {
      checked: this.state.isDismissChecked,
      onChange: this.handleDismissCheckChange
    }, toI18nText('dismissCheckbox')));
  },
  render: function render() {
    var open = this.state.open;

    var _this$getEntity$getDa2 = this.getEntity().getData(),
        phrase = _this$getEntity$getDa2.phrase;

    return _react.default.createElement(_UIPopover.default, {
      use: "shepherd",
      width: 350,
      open: open,
      placement: "bottom left",
      content: {
        header: _react.default.createElement("h4", null, toI18nText('title')),
        body: _react.default.createElement("span", null, toI18nText('description', {
          phrase: phrase
        })),
        footer: this.renderFooter()
      }
    }, _react.default.createElement("span", null, this.props.children));
  }
});

var _default = (0, _generalStore.connect)(dependencies)(MeetingsProTip);

exports.default = _default;
module.exports = exports.default;